module.exports = __webpack_public_path__ + "img/Mastercard.ff096cfe.svg";